/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React /* , { useState } */ from 'react';
// import { Dropdown } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// import { Filter } from './TableFilters';

function TableFilter({ column, filters, index }) {
  // const [show, setShow] = useState(false);
  // const { t } = useTranslation();
  return (
    <div className="d-flex align-items-center">
      <div
        {...column.getSortByToggleProps([
          {
            className: classNames(
              'd-flex flex-nowrap align-items-center',
              column.labelClasses && column.labelClasses({ column, index })
            ),
            style: column.labelStyles ? column.labelStyles({ column, index }) : null,
          },
        ])}
      >
        {column.render('Header')}
        {column.canSort && (
          <i
            className={`${!column.isSorted ? 'text-ultra-light' : 'text-primary'} fas ms-2 ${
              !column.isSorted ? 'fa-sort' : column.isSortedDesc ? 'fa-sort-down' : 'fa-sort-up'
            }`}
          />
        )}
      </div>
      {column.renderHeader && <>{column.renderHeader(column)}</>}
    </div>
  );
}

TableFilter.propTypes = {
  /**
   * The table colum object
   */
  column: PropTypes.object.isRequired,
  /**
   * The table filters array
   */
  filters: PropTypes.array,
};

export default TableFilter;
